export default {
  navigationSectionIds: {
    main: 'MAIN_NAVIGATION',
    footer_about: 'FOOTER_ABOUT',
    footer_terms: 'FOOTER_TERMS'
  }
}



// WEBPACK FOOTER //
// ./src/config/navigation.js